var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86 7.925 3.3 9.875a1 1 0 0 0 .78 1.625h7.84a1 1 0 0 0 .78-1.625l-1.56-1.95a3 3 0 0 1-.399-3.093l.634-1.426A1 1 0 0 0 10.461 2H5.54a1 1 0 0 0-.914 1.406l.634 1.426a3 3 0 0 1-.399 3.093Z",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.539 2.625a.375.375 0 0 0-.343.527.625.625 0 0 1-1.142.508 1.625 1.625 0 0 1 1.485-2.285h4.922a1.625 1.625 0 0 1 1.485 2.285l-1.22 2.746 1.112 1.391a.625.625 0 1 1-.976.781L9.512 6.89a.625.625 0 0 1-.083-.644l1.375-3.094a.375.375 0 0 0-.343-.527H5.54Zm-4.553.52a.625.625 0 0 1 .87-.159l4.44 3.074 8.56 5.926a.625.625 0 1 1-.712 1.028l-1.515-1.05c-.212.103-.451.161-.71.161H8.625V15a.625.625 0 1 1-1.25 0v-2.875H4.081c-1.363 0-2.12-1.576-1.27-2.64l2.223-2.778-3.89-2.693a.625.625 0 0 1-.158-.87ZM6.064 7.42l-2.276 2.846a.375.375 0 0 0 .293.609h6.974L6.065 7.42Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.542ff2961e3562b760a8323830cdc997.svg";
export { ForwardRef as ReactComponent };